import React from 'react';
import AuthComponent from './AuthComponent';

/**
 * User Authentication Component
 * For general user features like GPA Calculator, Resource access, etc.
 */
const UserAuth = ({ onAuthChange, title, description }) => {
  return (
    <AuthComponent
      context="user"
      onAuthChange={onAuthChange}
      title={title}
      description={description}
      benefits={[
        { icon: '☁️', text: 'Cloud Sync' },
        { icon: '🔒', text: 'Secure Storage' },
        { icon: '📱', text: 'Access Anywhere' }
      ]}
    />
  );
}

/**
 * GPA Calculator Specific Authentication
 */
const GPAAuth = ({ onAuthChange }) => {
  return (
    <AuthComponent
      context="gpa-calculator"
      onAuthChange={onAuthChange}
      title="Sign in to Save Your GPA Data"
      description="Connect with Google to securely store your GPA calculations and access them from any device."
      benefits={[
        { icon: '📊', text: 'Save Calculations' },
        { icon: '☁️', text: 'Cloud Backup' },
        { icon: '🔄', text: 'Sync Across Devices' },
        { icon: '📱', text: 'Access Anywhere' }
      ]}
    />
  );
};

/**
 * Admin Authentication Component
 * Restricted to specific email domains if needed
 */
const AdminAuth = ({ onAuthChange, allowedDomains = null }) => {
  return (
    <AuthComponent
      context="admin"
      onAuthChange={onAuthChange}
      allowedDomains={allowedDomains} // e.g., ['nhh.no'] for NHH admin only
      title="Admin Sign In"
      description="Sign in with your authorized Google account to access the admin dashboard."
      benefits={[
        { icon: '⚡', text: 'Admin Access' },
        { icon: '🛡️', text: 'Secure Login' },
        { icon: '📊', text: 'Full Control' }
      ]}
    />
  );
};

/**
 * Resource-specific Authentication
 * For other resources that may need authentication
 */
const ResourceAuth = ({ onAuthChange, resourceName, description }) => {
  return (
    <AuthComponent
      context="resource"
      onAuthChange={onAuthChange}
      title={`Sign in to Access ${resourceName}`}
      description={description || `Connect with Google to access ${resourceName} and save your progress.`}
      benefits={[
        { icon: '📂', text: 'Save Progress' },
        { icon: '☁️', text: 'Cloud Storage' },
        { icon: '🔄', text: 'Sync Data' }
      ]}
    />
  );
};

export { AdminAuth, GPAAuth, ResourceAuth, UserAuth };
export { default as useFirebaseAuth } from './useFirebaseAuth';
export { default as useAdminAuth } from './useAdminAuth';
